import {
  LOGIN,
  LOGIN_DETAILS,
  RESET,
} from "../actions/types";

const initialState = {
  isLogin: false,
  loginUser: null,
  clinicId: null,
  error: "",
  message: "",
  registerError: "",
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return { ...state, isLogin: action.payload, error: "" };
    case LOGIN_DETAILS:
      return { ...state, loginUser: action.payload };
    case RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default loginReducer;
